import { CROSSSELL_MEDIUM, CROSSSELL_SMALL, CROSSSELL_TINY } from 'bricks/CrossSell/constants';

/**
 * ouputs the proper word declensions by given count
 * @param count - count to determine appropriate case
 * @param titles - list of words in three cases: [nominative, genitive, multiplicative]
 * @returns {*}
 */
export function wordFormByCount(count, titles) {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
}

/**
 * splits price value into three-digit groups
 * */
export function formatPrice(price) {
  price = `${parseInt(price, 10)}`;
  let priceFormated = '';
  let count = 0;

  for (let i = price.length - 1; i >= 0; i -= 1) {
    priceFormated = !(count % 3) ? `${price[i]} ${priceFormated}` : `${price[i]}${priceFormated}`;

    count += 1;
  }

  return priceFormated;
}

/**
 * splits price value into three-digit groups without line brakes
 * */
export function formatPriceNoBrake(price) {
  price = `${parseInt(price, 10)}`;
  let priceFormated = '';
  let count = 0;

  for (let i = price.length - 1; i >= 0; i -= 1) {
    priceFormated =
      !(count % 3) ? `${price[i]}\u00A0${priceFormated}` : `${price[i]}${priceFormated}`;

    count += 1;
  }

  return priceFormated;
}

/**
 * Outputs price with rubles sign
 * if price is zero, outputs 'free'
 */
export function formatPriceExtended(price) {
  if (!price) return 'бесплатно';
  return `${formatPrice(price)} ₽`;
}

/**
 * Phone formatting
 */

export function formatPhone(phone) {
  if (!phone) return '';
  return `+7 (${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 8)}-${phone.slice(
    8,
    10,
  )}`;
}

export function unformatPhone(value) {
  if (!value) return value;
  const onlyNumbers = value.replace(/\D/gi, '');
  return onlyNumbers.slice(onlyNumbers.length - 10, onlyNumbers.length);
}
/**
 * Transform size to number of viewed items in slider
 */
export const sizeToNumber = (size) => {
  switch (size) {
    case CROSSSELL_TINY:
      return 1;
    case CROSSSELL_SMALL:
      return 2;
    case CROSSSELL_MEDIUM:
      return 3;
    default:
      return 4;
  }
};

export const formatMonthToString = (number) => {
  switch (number) {
    case 1:
      return 'января';
    case 2:
      return 'февраля';
    case 3:
      return 'марта';
    case 4:
      return 'апреля';
    case 5:
      return 'мая';
    case 6:
      return 'июня';
    case 7:
      return 'июля';
    case 8:
      return 'августа';
    case 9:
      return 'сентября';
    case 10:
      return 'октября';
    case 11:
      return 'ноября';
    case 12:
      return 'декабря';
    default:
      return '/';
  }
};

const isToday = (current, delivery) =>
  current.getFullYear() === delivery.getFullYear() &&
  current.getMonth() === delivery.getMonth() &&
  current.getDate() === delivery.getDate();

const isTomorrow = (current, delivery) =>
  current.getFullYear() === delivery.getFullYear() &&
  current.getMonth() === delivery.getMonth() &&
  current.getDate() + 1 === delivery.getDate();

export const getFormattedDeliveryDate = (dates, movementId, equipmentId, movementDate) => {
  if (dates.length < 1) {
    if (movementDate) {
      dates.push(movementDate);
    } else {
      return '';
    }
  }
  const closestDeliveryDate = new Date(dates[0]);
  const currentDate = new Date();
  const isThereNextDay = new Date(dates[1]);
  const deliveryDay = closestDeliveryDate.getDate();
  const deliveryMonth = closestDeliveryDate.getMonth() + 1;

  if (equipmentId) {
    return `После ${deliveryDay} ${formatMonthToString(deliveryMonth)} и позднее`;
  }

  if (movementId) {
    return `${deliveryDay} ${formatMonthToString(deliveryMonth)}`;
  }

  if (isToday(currentDate, closestDeliveryDate)) {
    return 'Сегодня';
  }

  if (isTomorrow(currentDate, closestDeliveryDate)) {
    return 'Завтра';
  }

  return isThereNextDay ?
      `После ${deliveryDay} ${formatMonthToString(deliveryMonth)} и позднее`
    : `После ${deliveryDay} ${formatMonthToString(deliveryMonth)}`;
};
